export default "__VITE_ASSET__e_JaFU$w__"